// extracted by mini-css-extract-plugin
export default {"main":"Button_main__vU33G","invert":"Button_invert__4zP8G","small":"Button_small__3A0Iy"};